export function MbscStructuredData() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "MBSC — Monobundle Stablecoin Core",
    applicationCategory: "FinanceApplication",
    operatingSystem: "Web",
    description:
      "日本円（銀行振込）とステーブルコイン（ERC-20 / 18 decimals）の発行・償還機能を提供するインフラストラクチャ。日本円→ステーブルコイン（Intent）と ステーブルコイン→日本円（Redemption）の両フローに対応し、認証・2FA・入金照合・オンチェーン送金・払い戻しを API で一括管理。",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "JPY",
      description: "導入相談は無料。詳細はお問い合わせください。",
    },
    provider: {
      "@type": "Organization",
      name: "モノバンドル株式会社",
      url: "https://monobundle.com",
    },
    featureList: [
      "日本円→ステーブルコイン（Intent）：日本円入金からステーブルコイン発行",
      "ステーブルコイン→日本円（Redemption）：ステーブルコイン送付から日本円払い戻し",
      "Cookie セッション認証（JWT / httpOnly）",
      "二要素認証（2FA / TOTP）",
      "KYC ステータス管理",
      "マルチチェーン対応（Ethereum, Polygon, Avalanche）",
      "バーチャル口座自動発行（GMOあおぞら等）",
      "内向き Webhook（銀行入金・オンチェーン入金）",
      "REST API（v1）",
      "Checkout SDK（React）",
      "Sandbox テスト環境",
      "Admin API（ユーザー・TX 履歴・ステーブルコイン 情報）",
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
